import api from "../../services/trainingServices"
import axios from "axios";
import { Notification } from 'element-ui';
import {EventBus} from "../../eventBus"

const state = {
    training_types: [],
    training_schedules: [],
    store_employees: [],
    store_stations: [],
    store_lists: [],
    designations_list: [],
    loading_trainings: false,
    store_sections: [],
    department_list: [],
    all_employees: [],
};

const mutations = {
    SET_TRAINING_TYPES(state, data){
        state.training_types = data;
    },
    SET_DEG_LIST(state, data){
        state.designations_list = data;
    },
    SET_TRAINING_SCHEDULE(state, data){
        state.training_schedules = data;
    },
    SET_DEPT_LIST(state, data){
        state.department_list = data;
    },
    SET_STORE_LISTS(state, data){
        data = data.filter((e)=> e.type === 'store');
        state.store_lists = data;
    },
    SET_STORE_SECTIONS(state, data){
        state.store_sections = data;
    },
    SET_STORE_EMPLOYEES(state, data){
        for (let e of data) {
            e.full_name = e.full_name + ` (${Object.keys(e.designation_info).length ? e.designation_info.name : '-'})`
        }
        state.all_employees = data;
        data = data.filter((e)=> e.active);
        state.store_employees = data;
    },
    SET_STORE_STATIONS(state, data){
        data = data.filter((e)=> e.function !== 'Excess' && e.function !== 'Training' && e.function !== 'Break')
        state.store_stations = data;
    },
};

const actions = {
    getTrainingTypesAction({ commit, dispatch }){
        api.getTrainingType().then((res) => {
            let result = JSON.parse(res.data);
            commit('SET_TRAINING_TYPES', result);
        }).catch((err) => {
            console.error(err)
        });
    },
    getTrainingsAction({ commit, dispatch }, payload){
        state.loading_trainings = true;
        api.getStoreEmployees({outlet_id: payload.store_id}).then((res) => {
            let result = JSON.parse(res.data);
            commit('SET_STORE_EMPLOYEES', result);
            // Run training API after getting employees
            api.getTrainingSchedule(payload).then((res) => {
                let result = JSON.parse(res.data);
                commit('SET_TRAINING_SCHEDULE', result);
                state.loading_trainings = false;
            }).catch((err) => {
                state.loading_trainings = false;
                console.error(err);
            });
        }).catch((err) => {
            state.loading_trainings = false;
            console.error(err);
        });
        
    },
    getStoreEmpAction({ commit, dispatch }, payload){
        api.getStoreEmployees(payload).then((res) => {
            let result = JSON.parse(res.data);
            // Make all employees name in lowercase
            // for (let emp of result) {
            //     emp.full_name = emp.full_name.toLowerCase();
            // }
            commit('SET_STORE_EMPLOYEES', result);
        }).catch((err) => {
            console.error(err)
        });
    },
    getStoreStations({ commit, dispatch }, payload){
        api.getStation(payload).then((res) => {
            // dispatch('getStoreSectionsAction', {store: payload.outlet_id})
            let result = JSON.parse(res.data);
            commit('SET_STORE_STATIONS', result);
        }).catch((err) => {
            console.error(err)
        });
    },
    getStoreLists({ commit, dispatch }){
        api.getAllStores().then((res) => {
            let result = JSON.parse(res.data);
            commit('SET_STORE_LISTS', result);
        }).catch((err) => {
            console.error(err)
        });
    },
    getDesignationAction({ commit, dispatch }, payload){
        api.getDesignation(payload).then((res) => {
            let result = JSON.parse(res.data);
            commit('SET_DEG_LIST', result);
        }).catch((err) => {
            console.error(err)
        });
    },
    getDepartmentAction({ commit, dispatch }, payload){
        api.getDepartment(payload).then((res) => {
            let result = JSON.parse(res.data);
            commit('SET_DEPT_LIST', result);
        }).catch((err) => {
            console.error(err)
        });
    },
    getStoreSectionsAction({ commit, dispatch }, payload){
        api.getStoreSections(payload).then((res) => {
            let result = JSON.parse(res.data);
            commit('SET_STORE_SECTIONS', result);
        }).catch((err) => {
            console.error(err)
        });
    },
};

const getters = {
    // getGroupName: (state) => (group_id) => {
    //     const group = state.allUserGroups.find((group) => group.id === group_id);
    //     return group ? group.name : '';
    // }
};

export default {
    state,
    mutations,
    actions,
    getters,
    namespaced: true
};
